/**
 * Manages the overflow of the body element when the dropdown is opened or closed.
 */
export const handleDropdown = (isOpen: boolean) => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
  };